import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-4 _gap-6--m _mt-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_gift_card_group_skeleton = _resolveComponent("backer-center-gift-card-group-skeleton")
  const _component_backer_center_gift_card_group = _resolveComponent("backer-center-gift-card-group")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_gift_card_history_modal = _resolveComponent("gift-card-history-modal")
  const _component_backer_center_layout = _resolveComponent("backer-center-layout")

  return (_openBlock(), _createBlock(_component_backer_center_layout, {
    size: "narrow",
    title: _ctx.Resources.BackerCenter.SectionGiftCardsHeader,
    "current-view": "giftCards"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($setup.isProcessing)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (index) => {
              return _createVNode(_component_backer_center_gift_card_group_skeleton, { key: index })
            }), 64 /* STABLE_FRAGMENT */))
          : ($data.giftCardGroups.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.giftCardGroups, (group) => {
                return (_openBlock(), _createBlock(_component_backer_center_gift_card_group, {
                  key: $options.giftCardGroupKey(group),
                  group: group,
                  onViewHistory: $options.viewGiftCardHistory
                }, null, 8 /* PROPS */, ["group", "onViewHistory"]))
              }), 128 /* KEYED_FRAGMENT */))
            : (_openBlock(), _createBlock(_component_box, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_empty_state, {
                    title: _ctx.Resources.BackerCenter.GiftCardsEmptyStateHeader,
                    description: _ctx.Resources.BackerCenter.GiftCardsEmptyStateParagraph,
                    "data-qa": "backer-gift-cards:EmptyState"
                  }, null, 8 /* PROPS */, ["title", "description"])
                ]),
                _: 1 /* STABLE */
              }))
      ]),
      _createVNode(_component_gift_card_history_modal, {
        ref: "giftCardHistoryModal",
        "load-history": $options.loadGiftCardHistory
      }, null, 8 /* PROPS */, ["load-history"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title"]))
}